import { FE_PDP_CLICK_PREFETCH_250527 } from "@faire/retailer-settings/FE_PDP_CLICK_PREFETCH_250527";
import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingPdpClickPrefetch = (): boolean => {
  return useSetting(FE_PDP_CLICK_PREFETCH_250527);
};
